import { render, staticRenderFns } from "./chemBaseDetailInfo.vue?vue&type=template&id=7cec289c"
import script from "./chemBaseDetailInfo.vue?vue&type=script&lang=js"
export * from "./chemBaseDetailInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cec289c')) {
      api.createRecord('7cec289c', component.options)
    } else {
      api.reload('7cec289c', component.options)
    }
    module.hot.accept("./chemBaseDetailInfo.vue?vue&type=template&id=7cec289c", function () {
      api.rerender('7cec289c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/chem/chemBaseDetailInfo.vue"
export default component.exports